import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  geoIp: {
    lat: 17.4065,
    lng: 78.4772,
  },
  callDefaultQuestion: false,
  callMsg: "",
};

const commonSlice = createSlice({
  name: "commonSlice",

  initialState,
  reducers: {
    setGeoIP: (state, { payload }) => {
      // state.geoIp = payload
    },
    setDefaultQuestion: (state, { payload }) => {
      state.callDefaultQuestion = payload.status;

      state.callMsg = payload.msg;
    },
  },
});
export default commonSlice.reducer;

export const { setGeoIP, setDefaultQuestion } = commonSlice.actions;
